import { Component, Input } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { environment } from '../../../../environments/environment';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';

@Component({
  selector: 'calsoft-new-banner',
  imports: [DefaultLayoutDirective, DefaultLayoutAlignDirective, CustomFlexLayoutModule, EditorTextComponent, DefaultStyleDirective, DefaultFlexDirective, NgOptimizedImageComponent],
  templateUrl: './new-banner.component.html',
  styleUrl: './new-banner.component.scss'
})
export class NewBannerComponent {

   public serverPath = environment.commonImageApi + '/commonSlider/';

  public serverPath1 = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() img: any;

  @Input() data: any;

  constructor(
    private commonService: CommonService,
  ) {

  }


  imageNavigation(id  :any){


    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }
  
  }

  link(url :any) {

    this.commonService.goToLink(url)
  }
  
}
